import React, { useState, useEffect } from 'react';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { RayTable, RayTreeview, AdminUserListHeader } from '../../components/common';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import { AdminUserAction } from '../../actions';
import CustomHeader from '../../components/common/CustomHeader';
import { CustomFieldAction } from '../../actions';
import { AdminFunctions } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';
import { buildAdminUserListRows } from '../../lib/adminUserListRow';
import { applyHeaderPrefs } from '../../lib/headerPrefs';

export const computeUserExHeader = (user, dfilters, baseHeaderNames) => {
	const users = user?.adminheaders?.users;
	const bases = Array.isArray(baseHeaderNames) ? baseHeaderNames : [];
	return users ? users.filter(x => (dfilters || []).map(m => m.code).includes(x.name) && !bases.includes(x.name)) : [];
};

const AdminUserList = ({ customs, GetUserAll, users, filter, user, viewTree, companies, isLoading }) => {

	const [wHg, setwHg] = useState(300);
	const [wAll, setwAll] = useState(window.innerWidth);
	const [selList, setSelList] = useState([]);
	const [filterCompanyId, setFilterCompanyId] = useState("");
	const [filterCompany, setFilterCompany] = useState({ name: "ALL" });

	const [exheader, setExHeader] = useState([]);
	const [header, setHeader] = useState([]);
	const [ready, setReady] = useState(false);
	const [showCHModal, setShowCHModal] = useState(false);
	const [dfilters, setdFilters] = useState(false);

	const dispatch = useDispatch();

	const options = {
		showClear: true,
		search: true,
		keyCol: 'adminid',
		linkto: '/Admin/AdminUserInfo',
		linkkey: 'adminid',
		filterpageoption: {
			filterDateOptions: [
				{ code: 'createDate', label: t('common.status.registered') },
			],
		},
		filterColumns: [
			{ col: 'adminType', val: 'ALL' },
			{ col: 'function', val: 'ALL' },
		],
		sort: { createDate: -1 },
		defaultSort: 'createDate',
	};

	const getWidth = () => setwAll(window.innerWidth);

	const checked = (list) => {
		setSelList(list);
	};

	useEffect(() => {
		setReady(header.length > 0);
	}, [header]);

	useEffect(() => {
		if (viewTree) {
			setwHg(300);
		} else {
			setwHg(0);
		}
		//setFilterCompanyId({});
	}, [viewTree]);

	useEffect(() => {
		// window.addEventListener('resize', getWidth);
		// setwAll(window.innerWidth);
		//GetCustomAll();
		GetUserAll();
		dispatch({ type: ProgramConstant.VIEWTREE, val: true });
	}, []);

	useEffect(() => {
		const newfilters = [];
		customs.filter(m => m.group.includes("USER")).map(x => {
			if (x.valuetype == "FIXLIST") {
				const mList = [];
				x.listvals.map(l => mList.push({ code: l, title: l }));
				newfilters.push({ code: "customfieldvals." + x.code, type: x.valuetype, name: x.title, fixlist: mList });
			} else {
				newfilters.push({ code: "customfieldvals." + x.code, type: x.valuetype, name: x.title });
			}
		});
		setdFilters(newfilters);
	}, [customs]);

	useEffect(() => {
		setReady(header.length > 0);
	}, [header]);

	useEffect(() => {
		let tempHeader = AdminUserListHeader;

		if (user.adminType == 'S')
			tempHeader = [...tempHeader, { name: 'lastLoginDate', label: t('common.label.lastLogin'), type: 'DT' }];

		const composedHeader = exheader.length > 0 ? tempHeader.concat(exheader) : tempHeader;
		setHeader(applyHeaderPrefs(composedHeader, user?.adminheaders?.users));
	}, [exheader, user?.adminheaders?.users]);

	useEffect(() => {
		const baseNames = Array.isArray(AdminUserListHeader) ? AdminUserListHeader.map(x => x?.name) : [];
		setExHeader(computeUserExHeader(user, dfilters, baseNames));
	}, [user.adminheaders?.users, dfilters]);

	// PR #185 R1 Blocker 회귀 방어: row builder 를 순수 함수(buildAdminUserListRows)로 분리.
	// Redux store user 를 mutate 하지 않고 새 row 객체만 반환 → flip 버그 차단. 단위 테스트로 invariant 고정.
	const genUserData = () => buildAdminUserListRows(users, { t, adminFunctions: AdminFunctions });

	const onChangeTreeviewItem = (item) => {
		setFilterCompanyId({ companyId: item.id });
		setFilterCompany(item);
	}

	const updateViewTree = (bl) => {
		dispatch({ type: ProgramConstant.VIEWTREE, val: bl });
	}

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">{t('user.title')}
					{companies.length > 1 && <button className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => updateViewTree(!viewTree)}>
						{filterCompany.name && <>
							{filterCompany.country && "[" + filterCompany.country + "] "}{filterCompany.name}
						</>}
					</button>}
				</h2>
				<div className="ray-right">
					<button onClick={() => setShowCHModal(true)} className="btn btn-sm mt-0">
						<ion-icon name="options-outline"></ion-icon> {t('common.label.customHeaders')}
					</button>
					<Link to="/Admin/AdminUserAdd" className="btn btn-primary btn-sm mt-0">
						<ion-icon name="add-outline"></ion-icon>
						{t('user.button.add')}
					</Link>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{(viewTree && user.adminType != "U") &&
					<div className={viewTree ? "section fl p-0" : "section p-0 fl"} style={{ width: wHg }}>
						<div className='p-1'>
							<RayTreeview onClickItem={onChangeTreeviewItem} onResize={setwHg} stateKey={LIST_STATE_KEYS.ADMIN_USER} />
						</div>
					</div>}
				{ready && <div className="section m-1 p-0">
					<div className="card p-2">
						<div className={user.adminType != "U" ? "fl" : ""}
							style={viewTree && user.adminType != "U" ? { width: wAll - (viewTree ? 354 : 68) } : {}}>
							<RayTable
								stateKey={LIST_STATE_KEYS.ADMIN_USER}
								data={genUserData()}
								addFilter={filterCompanyId}
								columns={header}
								isLoading={isLoading}
								checkBoxCallback={checked}
								options={options} />
						</div>
						<div className="clearfix"></div>
					</div>
				</div>}
			</div>
			<CustomHeader
				extratrakey={"USEREXTRAKEY"}
				title={t('common.label.userListHeader')}
				extratrakeyname={"extradata"}
				exHeader={exheader}
				adminheaderprefix={"users"}
				showModal={showCHModal}
				callbackClose={() => setShowCHModal(false)}
				defaultFilter={dfilters || []}
				baseHeader={header} />
		</>
	);
};

const mapState = (state) => {
	const users = state.AdminUserReducer.users;
	const user = state.AuthReducer.user;
	const filter = state.AdminUserReducer.filter;
	const viewTree = state.ProgramReducer.viewtree;
	const companies = state.CompanyReducer.companies;
	const customs = state.CustomFieldReducer.items;
	const isLoading = state.AdminUserReducer.isLoading;
	return { customs, users, filter, user, viewTree, companies, isLoading };
};

const mapDispatch = (dispatch) => ({
	GetUserAll: () => dispatch(AdminUserAction.GetUserAll()),
	//GetCustomAll: () => dispatch(CustomFieldAction.GetAll()),
});

export default connect(mapState, mapDispatch)(AdminUserList);
